import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { FlexRow } from 'ui-components/components/flex';
import { Text } from 'ui-components/components/text';

import messages from './messages';
import OrderItems from './order-items/order-items';
import style from './order-items-section.module.less';
import { OrderDetailsSectionId } from '../../fulfillment-plan/order-details-expanded-section-provider';
import ExpanderSection from '../../tab-section/expander-section/expander-section';
import SectionTitle from '../../tab-section/title';

export const OrderItemsSection = ({ salesOrderItemCount }) => {
  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.orderItemsSectionLabel}
      className={style['expander-section']}
      contentClassName={style['expander-content-order-items']}
      headerContent={
        <FlexRow className={style['expander-header-order-items']}>
          <SectionTitle messageDescriptor={messages.orderItems} />
          <Text
            className={style['items-count']}
            textType='Caption'
            value={<FormattedMessage {...messages.orderItemsCount} values={{ salesOrderItemCount }} />}
          />
        </FlexRow>
      }
      sectionContent={<OrderItems />}
      sectionId={OrderDetailsSectionId.OrderItems}
    />
  );
};

OrderItemsSection.propTypes = {
  salesOrderItemCount: PropTypes.number.isRequired,
};
